import { Field } from "csi/def/Field";
import Widget from "csi/form/Widget";
import declare from "dojo/_base/declare";

const ITEMS_PRODUCT_TYPES = "ItemsProductTypes";
const BOM_LABEL_SUBTYPE = "BOMLabelSubtype";

const FoodBOMSubtypeForm = declare(Widget, {

	/**
	 * @override
	 * Hide BOMLabelSubtype field initially
	 * @param fields
	 */
	_buildFields(fields: Field[]) {
		this.inherited(arguments);

		this.setFieldHidden(BOM_LABEL_SUBTYPE, true);
	},

	/**
	* @override
	* Add additional logic to check and hide BomLabelSubtype field if
	* Food or FormulatedMaterial was selected in ItemsProductTypes field
	*/
	onChangeField(field: Field) {
		this.inherited(arguments);

		const selectedValues = field.getValue();
		if (field.m_id === ITEMS_PRODUCT_TYPES) {
			// Hide field if neither Food or FormulatedMaterial is selected
			const isSelected = selectedValues.includes("ProductType:Food") || selectedValues.includes("ProductType:FormulatedMaterial");

			this.setFieldHidden(BOM_LABEL_SUBTYPE, !isSelected);
		}
	},
});

export = FoodBOMSubtypeForm;